<div class="chatBotContainer" #chatBotContainer>
  <!-- <div class="chatWindow" *ngIf="isChatWindowOpen">
    <div class="chatWindowHead">
      <h4>NishBot</h4>
      <button class="closeBtn" (click)="toggleChatWindow()">×</button>
    </div>

    <div class="messageArea">
      <div class="botMessage">
        👋 Hi there! I'm <strong>Nishwik</strong>, your banking assistant.  
        <br />
        I can help you with account info, transactions, services & more.
      </div>
    </div>

    <div class="sendMessageArea">
      <input type="text" placeholder="Type your question..." />
      <button><i class="bi bi-send-fill"></i></button>
    </div>
  </div> -->

  <div class="raiseTokenWindow" *ngIf="isChatWindowOpen && !selectedIssue">
    <ul class="chatbot-questions">
      <li
        *ngFor="let issue of suggestedIssues; let i = index"
        (click)="onIssueSelect(i); $event.stopPropagation()"
      >
        {{ issue }}
      </li>
    </ul>
    <div class="sendMessageArea">
      <input
        type="text"
        placeholder="Write your problem..."
        [formControl]="enteredIssue"
      />
      <button
        [ngClass]="{
          disabled:
            !enteredIssue.value ||
            (enteredIssue.value && enteredIssue.value.length < 3)
        }"
        type="button"
        (click)="onIssueSelect(); $event.stopPropagation()"
      >
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
  </div>

  <div class="sendEmailOrCallWindow" *ngIf="isChatWindowOpen && selectedIssue">
    <!-- <div class="contact-icons-wrapper d-flex flex-column align-items-center">

      <div
        class="icon-circle contact-icon-box d-flex justify-content-center align-items-center"
      >
        <img
          src="assets/images/mail.png"
          alt="Mail Icon"
          style="width: 40px; height: 40px"
        />
      </div>

      <div
        class="icon-circle contact-icon-box mb-3 d-flex justify-content-center align-items-center"
      >
        <img
          src="assets/images/call.png"
          alt="Call Icon"
          style="width: 40px; height: 40px"
        />
      </div>
    </div> -->

    <div class="modal-content p-1 credentials-card">
      <div class="modal-body">
        <form
          class="p-3 patient-info-form"
          [formGroup]="userInfoForm"
          (submit)="submitForm()"
        >
          <div class="patient-form-wrapper">
            <!-- Name -->
            <div class="form-row">
              <div class="form-group">
                <label>Name <span style="color: #e74c3c">*</span></label>
                <input
                  type="text"
                  placeholder="John Doe"
                  formControlName="userName"
                  (keypress)="allowAlphabetsAndSpaceOnly($event)"
                />
                <small
                  class="error"
                  *ngIf="
                    userInfoForm.get('userName')?.touched &&
                    userInfoForm.get('userName')?.invalid
                  "
                >
                  User name is required
                </small>
              </div>
            </div>

            <!-- Email -->
            <div class="form-row">
              <div class="form-group">
                <label>Email <span style="color: #e74c3c">*</span></label>

                <input
                  type="email"
                  placeholder="john@gmail.com"
                  formControlName="email"
                />

                <div
                  *ngIf="
                    (userInfoForm.get('email')?.invalid &&
                      userInfoForm.get('email')?.dirty) ||
                    (userInfoForm.get('email')?.touched &&
                      userInfoForm.get('email')?.invalid)
                  "
                >
                  <!-- Required -->
                  <small
                    class="error"
                    *ngIf="
        userInfoForm.get('email')?.touched &&
        userInfoForm.get('email')?.errors?.['required']
      "
                  >
                    Email is required
                  </small>

                  <!-- Invalid format -->
                  <small
                    class="error"
                    *ngIf="
        userInfoForm.get('email')?.touched &&
        userInfoForm.get('email')?.errors?.['email']
      "
                  >
                    Enter a valid email address
                  </small>
                </div>
              </div>
            </div>

            <!-- Contact -->
            <div class="form-row">
              <div class="form-group">
                <label>Contact <span style="color: #e74c3c">*</span></label>

                <div class="phone-input-group">
                  <span>+91</span>
                  <input
                    type="text"
                    placeholder="9876543210"
                    formControlName="contactNumber"
                    maxlength="10"
                    (keypress)="onlyNumberAllowValidation($event)"
                  />
                </div>

                <small
                  class="error"
                  *ngIf="
                    (userInfoForm.get('contactNumber')?.invalid &&
                      userInfoForm.get('contactNumber')?.dirty) ||
                    (userInfoForm.get('contactNumber')?.touched &&
                      userInfoForm.get('contactNumber')?.invalid)
                  "
                >
                  <span
                    *ngIf="
                      userInfoForm.get('contactNumber')?.hasError('required')
                    "
                  >
                    Contact number is required.
                  </span>
                  <span
                    *ngIf="
                      userInfoForm.get('contactNumber')?.hasError('pattern')
                    "
                  >
                    Contact number must be 10 digits and start with 6, 7, 8, or
                    9.
                  </span>
                </small>

                <small
                  class="error text-danger"
                  *ngIf="
                    userInfoForm.get('contactNumber')?.hasError('duplicate')
                  "
                >
                  This mobile number is already registered.
                </small>
              </div>
            </div>

            <!-- Upload Document -->
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">
                  Attach Screenshot or Document
                  <span class="optional-text">(optional)</span>
                </label>

                <div class="file-upload-wrapper">
                  <input
                    type="file"
                    id="issueFile"
                    class="file-input"
                    accept="image/*,.pdf"
                    (change)="onFileUpload($event)"
                  />

                  <label for="issueFile" class="file-upload-btn">
                    <i class="fa-solid fa-paperclip"></i>
                    {{ attachedFile ? attachedFile.name : "Choose file" }}
                  </label>

                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <span class="file-hint"> PNG, JPG or PDF (max 5MB) </span>

                    <i
                      class="bi bi-x-circle-fill text-danger"
                      style="cursor: pointer"
                      *ngIf="attachedFile"
                      (click)="$event.stopPropagation(); attachedFile = null"
                    ></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit -->
            <div class="form-row">
              <button
                type="submit"
                class="universal-submit-btn"
                style="width: 100%"
              >
                Raise Ticket
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="chatBotBtn" (click)="toggleChatWindow()">
    <div class="defaultMessage shake-message" *ngIf="!isChatWindowOpen">
      Can I help you?
    </div>
    <i class="fa-solid fa-headset" style="font-size: 22px"></i>
  </div>
</div>
